<template>
  <div class="relative h-full w-full">
    <Line
      v-if="Array.isArray(chartData.datasets)"
      :options="chartOptions"
      :data="chartData"
    />
  </div>
</template>

<script>
// https://vue-chartjs.org/examples/
import { Line } from 'vue-chartjs'
import { detailedTablePlugin } from './plugins/detailedTablePlugin.js'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  detailedTablePlugin
)

export default {
  name: 'LineChart',
  components: {
    Line
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    uniqid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index'
        },
        plugins: {
          htmlLegend: false,
          detailedTablePlugin: {
            containerID: this.uniqid,
            router: this.$router,
            mode: 'series'
          },
          legend: {
            display: true
          }
        }
      }
    }
  }
}
</script>

<style scoped></style>
